import { apiFetch, isWhitespaceString } from '@ami/react/core';
import DealerUserDealersFilter from './dealerUserDealersFilter';

const dealerUserDealersUrl = 'dealer-users-dealers';

const dealerUserDealersService = {
  search: async (filter = new DealerUserDealersFilter(), page) => {
    if (isWhitespaceString(filter.search))
      filter.search = null;

    filter.setPaginationParameters(page);
    const result = await apiFetch(
      `${dealerUserDealersUrl}?${filter.toQueryString()}`
    );
    return result;
  },
  getUser: (id) => {
    return apiFetch(`${dealerUserDealersUrl}/${id}`);
  },
  createUser: (dealerUser, automaticSuccessNotification = true) => {
    return apiFetch(dealerUserDealersUrl, 'POST', dealerUser, {
      automaticSuccessNotification: automaticSuccessNotification,
    });
  },
  updateUser: (dealerUser) => {
    return apiFetch(
      `${dealerUserDealersUrl}/${dealerUser.userId}`,
      'PUT',
      dealerUser
    );
  },
  downloadCsv: () => {
    return apiFetch(`${dealerUserDealersUrl}/csv`);
  },
};
export { dealerUserDealersService };
